<template>
  <div class="biddingConfirm">
    <div v-show="status==='projectList'">
      <project-table
        ref="projectTable"
        :operateColumns="operateColumns"
        :extraQuery="extraQuery"
      ></project-table>
    </div>
    <div v-if="status==='confirmProject'">
      <project-card
        :projectData="projectData"
        @back="backList"
      ></project-card>
      <group-confirm :projectData="projectData"></group-confirm>
    </div>
    <div v-if="status==='biddingArticles'">
      <project-card
        :projectData="projectData"
        @back="backList"
      ></project-card>
      <bidding-articles
        :projectData="projectData"
        :articles="biddingArticles"
        @refreshArticles="getArtilces"
      ></bidding-articles>
    </div>
    <Modal
      class="print-modal"
      v-model="printVisible"
      title="通知书打印"
      width="1200"
    >
      <iframe
        :src="printUrl"
        style="width:100%;height:600px;"
      ></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import ProjectCard from '@/views/documentation/projectCard'
import GroupConfirm from './groupConfirm'
import BiddingArticles from '@/views/documentation/articles/biddingArticles'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { getProjectPermission } from "@/lib/projectPermission"
import { isWeiXin } from '@/lib/tool'

export default {
  name: 'biddingConfirm',
  components: {
    ProjectTable,
    ProjectCard,
    GroupConfirm,
    BiddingArticles
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'biddingConfirm') {
        this.$refs.projectTable.refreshProject()
      }
    }
  },
  data() {
    return {
      operateColumns: [
        {
          title: '操作',
          width: 170,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px'
                },
                on: {
                  click: () => {
                    this.selectProject(params.row)
                  }
                }
              }, '中标确认'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginTop: '5px'
                },
                on: {
                  click: () => {
                    this.projectData = params.row
                    this.status = 'biddingArticles'
                    // 获取中标公告
                    this.getArtilces()
                  }
                }
              }, '中标挂网')
            ])
          }
        },
        {
          title: '通知书打印',
          width: 130,
          render: (h, params) => {
            let disabled = true
            if (params.row.projectState === '已开评标完') {
              disabled = false
            }
            let isSurveyProject = params.row.businessType === '采购咨询' && params.row.projectProperty === '市场调研'
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: disabled || isSurveyProject
                },
                style: {
                  marginTop: '5px'
                },
                on: {
                  click: async () => {
                    // 限制进入4.0立项
                    if (params.row.dataSource === '4.0立项') {
                      this.$Modal.confirm({
                        title: '温馨提示',
                        content: '中标通知书打印功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
                        cancelText: '取消',
                        okText: '立即前往',
                        onOk: () => {
                          if (isWeiXin()) {
                            window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                          } else {
                            window.open('https://qy.choicelink.cn:8440')
                          }
                        }
                      })
                      return
                    }
                    // 中标确认检查
                    this.$Spin.show()
                    try {
                      let rep = await ajax.get(requestUrls.enroll.GetPagedExt, {
                        params: {
                          filter: `projectId=="${params.row.id}" and status = "true"`,
                          maxResultCount: 5,
                          skipCount: 0
                        }
                      })
                      this.$Spin.hide()
                      if (!rep.data.success || rep.data.result.items.length === 0) {
                        this.$Message.info('请先中标确认')
                        return
                      }
                    } catch (err) {
                      console.error(err)
                      this.$Spin.hide()
                      this.$Message.error('操作失败')
                      return
                    }

                    this.printUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=zhongbiao/ZhongBiao.cpt&op=write&NPID=${params.row.id}`
                    this.printVisible = true


                    // this.printUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=zhongbiao/ZhongBiao.cpt&op=write&NPID=${params.row.id}`
                    // this.printVisible = true

                  }
                }
              }, '中标通知书打印'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: disabled || isSurveyProject
                },
                style: {
                  marginTop: '5px',
                  marginBottom: '5px'
                },
                on: {
                  click: () => {
                    // 限制进入4.0立项
                    if (params.row.dataSource === '4.0立项') {
                      this.$Modal.confirm({
                        title: '温馨提示',
                        content: '缴费通知书打印功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
                        cancelText: '取消',
                        okText: '立即前往',
                        onOk: () => {
                          if (isWeiXin()) {
                            window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                          } else {
                            window.open('https://qy.choicelink.cn:8440')
                          }
                        }
                      })
                      return
                    }
                    // 检查是否审核通过
                    // 未发起申请
                    if (!params.row.winBidCheck) {
                      this.$Modal.confirm({
                        title: '未发起审核',
                        content: '未发起审核，是否发起审核？',
                        onOk: async () => {
                          params.row.winBidCheck = 1
                          try {
                            this.$Spin.show()
                            let rep = await ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
                              clProjectDb: params.row
                            })
                            this.$Spin.hide()
                            if (rep.data.success) {
                              this.$Message.success('已发起申请')
                            } else {
                              this.$Message.error('发起申请失败')
                            }
                          } catch (err) {
                            console.error(err)
                            this.$Spin.hide()
                            this.$Message.error('发起申请失败')
                          }
                        }
                      })
                    } else {
                      // 申请中
                      if (params.row.winBidCheck == 1) {
                        this.$Message.info('正在申请中，请等待审核通过')
                      }
                      // 通过
                      if (params.row.winBidCheck == 2) {
                        this.printUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=zhongbiao%2FJiaoFei_main.cpt&op=write&NPID=${params.row.id}`
                        this.printVisible = true
                      }
                      // 不通过
                      if (params.row.winBidCheck == 3) {
                        this.$Modal.confirm({
                          title: '审核不通过',
                          content: '审核不通过，是否重新发起审核？',
                          onOk: async () => {
                            params.row.winBidCheck = 1
                            try {
                              this.$Spin.show()
                              let rep = await ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
                                clProjectDb: params.row
                              })
                              this.$Spin.hide()
                              if (rep.data.success) {
                                this.$Message.success('已发起申请')
                              } else {
                                this.$Message.error('发起申请失败')
                              }
                            } catch (err) {
                              console.error(err)
                              this.$Spin.hide()
                              this.$Message.error('发起申请失败')
                            }
                          }
                        })
                      }
                    }

                    // this.printUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=zhongbiao%2FJiaoFei_main.cpt&op=write&NPID=${params.row.id}`
                    // this.printVisible = true
                  }
                }
              }, '缴费通知书打印')
            ])
          }
        }
      ],
      extraQuery: {
        status: ' and (projectState == "已挂网文件售卖中" or projectState == "开评标中" or projectState == "已开评标完" or projectState == "项目失败")',
        rolePermission: ''
      },
      status: 'projectList',
      projectData: {},
      printUrl: '',
      printVisible: false,
      biddingArticles: []
    }
  },
  methods: {
    selectProject(row) {
      this.projectData = row
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '中标确认已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      this.status = 'confirmProject'
    },
    backList() {
      this.status = 'projectList'
      this.$refs.projectTable.refreshProject()
    },
    async getArtilces() {
      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          filter: `a.objectId=="${this.projectData.id}" and a.ext2=="74168"`, // 74168中标公告
          maxResultCount: 100,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        this.biddingArticles = rep.data.result.items
      }
    }
  }
}
</script>

<style lang="less">
.print-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
